import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { darkTheme } from '@stylesheets/theme';
import {
  Wrapper,
  FormSide,
  Logo,
  LogoIcon,
  FormContent,
  BackgroundSide,
  SpiralPattern,
} from './AuthLayout.styled';

interface AuthLayoutProps {
  children: React.ReactNode;
}

/**
 * Dark-themed auth layout. Left side: form content (420px).
 * Right side: geometric spiral pattern. Uses the MD3 dark theme.
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <ThemeProvider theme={darkTheme}>
      <Wrapper>
        <FormSide>
          <Logo
            role="button"
            tabIndex={0}
            aria-label="Go to homepage"
            onClick={() => navigate('/')}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate('/');
              }
            }}
          >
            <LogoIcon>AI</LogoIcon>
            Aibuild OS
          </Logo>
          <FormContent>{children}</FormContent>
        </FormSide>
        <BackgroundSide>
          <SpiralPattern />
        </BackgroundSide>
      </Wrapper>
    </ThemeProvider>
  );
};

export default AuthLayout;
